import MarketProductAttrAdd from "@/views/MarketProductAttr/MarketProductAttrAdd";
import MarketProductAttrList from "@/views/MarketProductAttr/MarketProductAttrList";
import MarketProductAttrEdit from "@/views/MarketProductAttr/MarketProductAttrEdit";


const routes = [
 {
    path: '/MarketProductAttr/Add',
    name: 'MarketProductAttrAdd',
    component: MarketProductAttrAdd,
    meta:{requiredAuth:true}
  },
 {
    path: '/MarketProductAttr/List',
    name: 'MarketProductAttrList',
    component: MarketProductAttrList,
    meta:{requiredAuth:true}
  },
 {
    path: '/MarketProductAttr/Edit/:id',
    name: 'MarketProductAttrEdit',
    component: MarketProductAttrEdit,
    meta:{requiredAuth:true}
  },

]

export default routes